// Lib
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { LINKEDIN } from '@/lib/socialProfile';

// Components
import { SimpleBarChart } from '@/components/composite/Charts/SimpleBarChart';

export const avgEngagementsPostTypeConfig = {
    title: 'chart.linkedin.avg_engagements_post_type',
    tooltip: 'chart.linkedin.tooltip_avg_engagements_post_type',
    id: 'average_engagement_per_post_type',
    noLegend: true,
    tickFormatterTranslation: 'analytics:chart.post_type_linkedin',
    tableColumnFormatterTranslation: 'analytics:chart.post_type_linkedin',
    margin: {
        left: -40
    },
    name: {
        type: 'chart.linkedin.avg_engagements_post_type_type',
        value: 'chart.linkedin.avg_engagements_post_type_value'
    },
    social: LINKEDIN,
    valueFormat: classicFormat,
    color: {
        value: 'blue'
    },
    size: SIZE_50,
    type: 'chart',
    element: SimpleBarChart
};
